import React, { Component } from 'react'
import { connect } from 'react-redux'
import FuelCredit from './FuelCredit'
import PropTypes from 'prop-types'
import { actions } from '../Services/FuelCredit'
import * as checkoutActions from 'features/Checkout/actions'
import { push } from 'connected-react-router'

const errorTitle = 'Não foi possível concluir o sua transação.'
const errorDescription =
  'Vamos tentar novamente, por favor verifique os campos baixo.'

class FuelCreditContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isloading: true,
      loadingPayment: false,
      shellSupplierId: 117,
      errorPage: {
        title: errorTitle,
        description: props.descriptionErrorFuelCredit || errorDescription,
        hasError: props.sendRedemptionError
      },
      error: null,
      successPage: null,
      errorField: null,
      acceptTerms: false,
      packageSelected: props.packageSelected || {},
      isValid: null,
      regulationType: 'Vendor',
      showModal: false
    }
    this.handlerChangePackage(this.state.packageSelected)
    this.handlerFinalizePayment = this.handlerFinalizePayment.bind(this)
  }
  componentDidMount () {
    if (!this.props.packages || this.props.packages.length < 1) {
      this.props.loadPackagesBySupplierId(
        this.state.shellSupplierId,
        this.props.clientId
      )
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.order !== this.props.order) {
      this.props.navigateToServiceConfirmation(this.props.order.liveOrderId)
    }
  }

  handlerChangePackage = packageSelected => {
    this.setState({ packageSelected, isValid: null })
  }

  acceptTermsEvent = checked => {
    this.setState({
      showModal: false,
      acceptTerms: checked
    })
  }

  showTermsEvent = () => {
    this.setState({
      showModal: true
    })
  }

  closeterms = () => {
    this.setState({ showModal: false })
  }

  handlerFinalizePayment = () => {
    if (
      this.props.participantBalance < this.state.packageSelected.pointsQuantity
    ) {
      return this.handlerShowErrorPage(
        'Não foi possível concluir o sua transação.',
        'Seu saldo é insuficiente.',
        true
      )
    }
    if (
      !this.props.participant.partnerCpf.value
    ) {
      return this.handlerShowErrorPage(
        'Não foi possível concluir a sua transação.',
        'Para realizar a transferência de pontos é necessário ter um CPF cadastrado. Por favor, atualize o seu cadastro.',
        true
      )
    }

    const orderFuelCredit = {
      totalMiles: this.state.packageSelected.milesQuantity,
      totalPoints: this.state.packageSelected.pointsQuantity,
      transferKey: 'cpf',
      loyaltyNumber: this.props.participant.partnerCpf.value,
      cpf: this.props.participant.partnerCpf.value,
      participantName: this.props.participant.name.value,
      offline: false,
      orderItems: [
        {
          quantity: 1,
          points: this.state.packageSelected.pointsQuantity,
          miles: this.state.packageSelected.milesQuantity,
          totalPoints: this.state.packageSelected.pointsQuantity,
          packageName: this.state.packageSelected.title,
          clientProductCode: this.state.packageSelected.clientProductCode,
          pointsAdjustment: this.state.packageSelected.pointsAdjustment,
          partnerCampaignPackageId: this.state.packageSelected
            .partnerCampaignPackageId
        }
      ],
      orderTypeId: 1
    }

    this.props.redemptionFuelCredit(orderFuelCredit, this.state)
  }

  handleCloseError = () => {
    this.setState({ errorPage: { ...this.state.errorPage, hasError: false } })
    this.props.closeError()
    this.props.closeErrorMileage()
  }

  handlerCloseSuccess = () => {
    this.setState({ successPage: null })
  }

  handlerShowErrorPage = (title, description, hasError) => {
    this.setState({
      errorPage: {
        title: title,
        description: description,
        hasError: hasError,
        closeError: () => this.handleCloseError()
      }
    })
  }

  handlerFormatValue = (value, decimalPlaces) => {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    })
  }

  render () {
    const errorPage = {
      title: errorTitle,
      description:
        this.state.description ||
        this.props.descriptionErrorFuelCredit ||
        errorDescription,
      hasError: this.props.sendRedemptionError || this.state.hasError,
      closeError: () => this.handleCloseError()
    }

    return (
      <FuelCredit
        {...this.state}
        errorPage={this.state.errorPage || errorPage}
        packages={this.props.packages}
        handlerFinalizePayment={this.handlerFinalizePayment}
        handleCloseError={this.handleCloseError}
        acceptTermsEvent={this.acceptTermsEvent}
        closeterms={this.closeterms}
        showTermsEvent={this.showTermsEvent}
        packageSelected={this.state.packageSelected}
        handlerChangePackage={this.handlerChangePackage}
        currencyConfiguration={this.props.currencyConfiguration}
        shellSupplierId={this.state.shellSupplierId}
        regulationType={this.state.regulationType}
        acceptTerms={this.state.acceptTerms}
        showModal={this.state.showModal}
        handlerFormatValue={this.handlerFormatValue}
        loadingPayment={this.props.sendRedemptionMileage}
        isLoadingRedemption={this.props.isLoading}
        sendRedemption={this.props.sendRedemption}
        oidc={this.props.oidc}
        closeSecondFactorModal={this.props.closeSecondFactorModal}
        sendTwoFactorAuthorization={this.props.sendTwoFactorAuthorization}
        authorizeWithTokenMileage={this.props.authorizeWithTokenMileage}
        authorizeWithTokenResend={this.props.authorizeWithTokenResend}
        authorizeWithTokenLastTry={this.props.authorizeWithTokenResend}
        loadingResendToken={this.props.loadingResendToken}
        errorRedemption={this.props.errorRedemption}
      />
    )
  }
}

const mapStateToProps = ({
  fuelCredit,
  mileage,
  catalog: { currencyConfiguration },
  participant,
  balance: { pointsValue: participantBalance },
  oidc
}) => {
  const { user } = oidc
  const { profile } = user || {}
  return {
    ...fuelCredit,
    currencyConfiguration,
    participant,
    participantBalance,
    clientId: profile && profile['custom:client_id'],
    oidc,
    isLoading: mileage.isLoading,
    errorRedemption: mileage.errorRedemption,
    sendRedemptionMileage: mileage.sendRedemptionMileage,
    pointsToMiles: mileage.pointsToMiles,
    sendTwoFactorAuthorization: mileage.sendTwoFactorAuthorization,
    loadingResendToken: mileage.loadingResendToken,
    order: mileage.order
  }
}

const mapDispatchToProps = dispatch => ({
  loadPackagesBySupplierId: (shellSupplierId, clientId) =>
    dispatch(actions.loadPackagesBySupplierId(shellSupplierId, clientId)),
  redemptionFuelCredit: (order, supplierId) =>
    dispatch(actions.redemptionFuelCredit(order, supplierId)),
  closeError: () => dispatch(actions.closeError()),
  closeErrorMileage: () => dispatch(actions.closeErrorMileage()),
  closeSecondFactorModal: () => dispatch({ type: 'CLOSE_SECOND_FACTOR' }),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      checkoutActions.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenMileage: (
    orderId,
    Token,
    orderIdMileage,
    vendorId,
    lastTry
  ) =>
    dispatch(
      actions.authorizeWithTokenMileage(
        orderId,
        Token,
        orderIdMileage,
        vendorId,
        lastTry
      )
    ),
  redirectConfirmation: orderId => dispatch(push(`/confirmation/${orderId}`)),
  navigateToServiceConfirmation: liveOrderId => {
    dispatch({ type: 'REDEMPTION_FUEL_CREDIT_SUCCESS' })
    dispatch(actions.navigateToServiceConfirmation(liveOrderId))
  }
})

const packageType = PropTypes.shape({
  description: PropTypes.string.isRequired,
  partnerId: PropTypes.number.isRequired
})

FuelCreditContainer.propTypes = {
  packages: PropTypes.arrayOf(packageType).isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadPackagesBySupplierId: PropTypes.func.isRequired,
  currencyConfiguration: PropTypes.object,
  participant: PropTypes.object,
  redemptionFuelCredit: PropTypes.func.isRequired,
  sendRedemptionError: PropTypes.bool,
  sendRedemption: PropTypes.bool,
  packageSelected: PropTypes.object,
  closeError: PropTypes.func,
  closeErrorMileage: PropTypes.func,
  sendRedemptionMileage: PropTypes.bool,
  participantBalance: PropTypes.number,
  descriptionErrorFuelCredit: PropTypes.string,
  clientId: PropTypes.string,
  oidc: PropTypes.object,
  closeSecondFactorModal: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  redirectConfirmation: PropTypes.func,
  loadingResendToken: PropTypes.bool,
  sendTwoFactorAuthorization: PropTypes.bool,
  authorizeWithTokenMileage: PropTypes.func,
  order: PropTypes.object,
  navigateToServiceConfirmation: PropTypes.func,
  errorRedemption: PropTypes.string
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FuelCreditContainer)



// WEBPACK FOOTER //
// ./src/features/FuelCredit/FuelCreditContainer.js